import loadable from "@loadable/component";
import classnames from "classnames";
import AdWhitelist from "components/Ads/AdWhitelist";
import Error404 from "components/Error404";
import WOWBuildsContainer from "components/Pages/Builds/WOWBuildsContainer";
import ClassSpecPageContainer from "components/Pages/ClassSpecPage/ClassSpecPageContainer";
import TierListsContainer from "components/Pages/TierLists/TierListsContainer";
import React from "react";
import { Route, Switch } from "react-router-dom";
import { useGlobal } from "reactn";
import { CLASSES_AND_SPECS } from "../lib/classes-and-specs";
import GearPageContainer from "./Pages/Combos/GearPageContainer";
import GemEnchantPageContainer from "./Pages/Combos/GemEnchantPageContainer";
import TrinketsPageContainer from "./Pages/Combos/TrinketsPageContainer";
import PvPTalentsContainer from "./Pages/PvP/PvPTalentsContainer";
import TalentsPageContainer from "./Pages/Talents/TalentsPageContainer";
import RouteStatus from "./RouteStatus";
import ProbuildsMythicPlusPage from "./Pages/ProBuilds/ProbuildsMythicPlusPage";
import ProbuildsPvPPage from "./Pages/ProBuilds/ProbuildsPvPPage";
import ProbuildsRaidPage from "./Pages/ProBuilds/ProbuildsRaidPage";
import EchoRoster from "./Pages/ProBuilds/Echo/EchoRoster";
import EchoProfile from "./Pages/ProBuilds/Echo/EchoProfile";
import MaxLandingPageContainer from "./Pages/LandingPage/MaxLandingPageContainer";

// Loadable Components
const LandingPageContainer = loadable(() => import("components/Pages/LandingPage/LandingPageContainer"));
const SupportUsPage = loadable(() => import("components/Pages/SupportUs/SupportUsPage"));
// const Settings = loadable(() =>
//   import("components/Accounts/Settings/Settings")
// );
const About = loadable(() => import("components/Pages/About/About"));
const FAQ = loadable(() => import("components/Pages/FAQ"));
const PrivacyPolicy = loadable(() => import("components/PrivacyPolicy"));
const PrivacyShield = loadable(() => import("components/PrivacyShield"));
const TermsOfService = loadable(() => import("components/TermsOfService"));
const Careers = loadable(() => import("components/Careers"));

const toPath = (name) => {
  return name.toLowerCase().split(" ").join("_");
};

const MainContent = (props) => {
  const { sideNavOpen } = props;
  const [verificationBar] = useGlobal("verificationBar");

  const mainContentClassNames = classnames({
    "verification-bar-active": verificationBar,
    collapsed: !sideNavOpen,
    expanded: sideNavOpen,
  });

  const buildPages = [
    {
      page: "talents",
      component: WOWBuildsContainer,
    },
    {
      page: "gear",
      component: GearPageContainer,
    },
    {
      page: "trinkets",
      component: TrinketsPageContainer,
    },
    {
      page: "gems-and-enchants",
      component: GemEnchantPageContainer,
    },
    {
      page: "builds",
      component: TalentsPageContainer,
    },
  ];

  return (
    <div id="main-content" className={mainContentClassNames} ref={props.forwardedRef}>
      <div id="content-wrapper">
        <div id="content">
          <Switch>
            <Route exact path="/" component={LandingPageContainer} />
            <Route exact path="/wow" component={LandingPageContainer} />
            <Route exact path="/support-us" component={SupportUsPage} />
            {CLASSES_AND_SPECS.map(({ class: className, specs }) =>
              specs.map(({ title: spec }) =>
                buildPages.map(({ page, component }) => {
                  const key = [className, spec, page].join("-");
                  const base = `/wow/${toPath(spec)}/${toPath(className)}/${page}`;
                  return <Route key={key} exact path={[base, `${base}/raid`]} component={component} />;
                }),
              ),
            )}
            <Route
              exact
              path={["/wow/tier-list/:filterRanking/raid", "/wow/tier-list/:filterRanking/pvp", "/wow/tier-list/:filterRanking"]}
              component={TierListsContainer}
            />
            <Route path="/wow/:spec/:class/pvp" component={PvPTalentsContainer} />
            <Route path="/wow/classes-and-specs" component={ClassSpecPageContainer} />
            <Route path="/terms-of-service" render={(props) => <TermsOfService {...props} />} />
            <Route path="/ad-whitelist" render={(props) => <AdWhitelist {...props} />} />
            <Route path="/privacy-policy" render={(props) => <PrivacyPolicy {...props} />} />
            <Route path="/privacy-shield" render={(props) => <PrivacyShield {...props} />} />
            <Route path="/careers" render={(props) => <Careers {...props} />} />
            {/* <DisabledRoute path="/settings" component={Settings} /> */}
            <Route path="/about" render={(props) => <About {...props} />} />
            <Route path="/wow/faq" render={(props) => <FAQ {...props} />} />

            {/* PROBUILDS TODO: Decide on URL format */}
            {/* <Route path="/wow/probuild/mythic+/:realm/:character" component={ProbuildsMythicPlusPage} />
            <Route path="/wow/probuild/pvp/:gamemode/:realm/:character" component={ProbuildsPvPPage} />
            <Route path="/wow/probuild/raid/:realm/:character" component={ProbuildsRaidPage} /> */}
            {/* Disabled Echo Route */}
            {/* <Route path="/wow/echo/:player" component={EchoProfile} />
            <Route path="/wow/echo" component={EchoRoster} /> */}
            {/* <Route path="/" render={() => <Redirect exact replace to="/wow/tier-list?encounterType=raid" />} /> */}
            {/* <Route path="/wow" render={() => <Redirect exact replace to="/wow/tier-list?encounterType=raid" />} /> */}
            <RouteStatus statusCode={404} path="*">
              <Error404 />
            </RouteStatus>
          </Switch>
        </div>
      </div>
    </div>
  );
};

export default MainContent;
